import styled from "@emotion/styled";
import { SpinnerLoaderProps } from "./spinner-loader.props";

export const LoadingWrapper = styled.div`
  text-align: center;
  height: ${(props: SpinnerLoaderProps) => props.height ?? "100%"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${(props: SpinnerLoaderProps) => props.padding || "2rem"};
`;

export const InnerLoaderWrapper = styled.div`
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
